import React, { useState } from 'react'
import styled from 'styled-components'
import { Rating } from 'react-simple-star-rating'
import { useForm } from 'react-hook-form';
import { apiCaller } from "@utils";
import { toast } from 'react-toastify';
import { ButtonComponent } from "@components/patterns/elements/Button";
import { Input } from 'reactstrap';
import DetailComment from './DetailComment';

const WrapFeedback = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: calc(100vh - 120px);
  overflow-y: scroll;
  padding-right: 8px;
  padding-left: 2px;
  padding-bottom: 20px;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #D6DBE3; 
    border-radius: 8px;
  }
`

const TitleFeedback = styled.h1`
  font-size: 20px;
  font-weight: 600;
`

const WrapRating = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0 16px;
  border-bottom: 1px solid #D0D5DD;
  .list-stars {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .rate-percent {
    font-size: 16px;
    font-weight: 600;
  }
  .rate-number {
    font-size: 16px;
    font-weight: 400;
  }
`

const FormRating = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
  h1 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    white-space: nowrap;
  }
`

const FormFeedback = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const fillColorArray = [
  "#f17a45",
  "#f19745",
  "#f1a545",
  "#f1b345",
  "#f1d045"
];

export default function FeedbackAndRating(props) {
  const { dataQuestionDetail, setDataQuestionDetail, permission } = props
  const Account = JSON.parse(localStorage.getItem("Account"));
  const isAddReview = dataQuestionDetail?.ReviewData?.some((data) => data?.email === Account?.email)
  const [showFormReview, setShowFormReview] = useState(false)
  const [, setRating] = useState(0);

  const {
    handleSubmit,
    setValue,
    watch,
  } = useForm()
  
  const handleRating1 = (rate) => {
    setRating(rate);
    setValue('rate', rate)
  }

  const onSubmit = (data) => {
    const params = {
      Action: "SubmitQuestionBankItemReview",
      QuestionItemId: dataQuestionDetail?.QuestionItemId,
      Stars: data?.rate,
      Comments: data?.suggestion
    };
    apiCaller(`/feedback/question/items/`, "POST", params).then((res) => {
      if (res?.status === 200) {
        console.log(res.data);
        toast.success("Review submitted successfully!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setDataQuestionDetail((prev) => ({
          ...dataQuestionDetail,
          AverageStar: res?.data?.AverageStar,
          ReviewData: res?.data?.ReviewData
        }))
        setValue('suggestion', '')
      } else {
        toast.error("Failed to feedback", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }
  return (
    <WrapFeedback>
      <TitleFeedback>Feedback & Rating</TitleFeedback>
      <WrapRating>
        <div className="list-stars">
          <Rating 
            readonly={true} 
            initialValue={dataQuestionDetail?.AverageStar} 
            allowFraction
          />
        </div>
        <p className="rate-percent">{dataQuestionDetail?.AverageStar || 0}</p>
        <p className="rate-number">({dataQuestionDetail?.ReviewData?.length || 0} Ratings)</p>
      </WrapRating>
      {dataQuestionDetail?.ReviewData?.length > 0 && dataQuestionDetail?.ReviewData.map((item, index) => {
        return (
          <DetailComment key={index} review={item} {...props}/>
        )})
      }
      {permission && !isAddReview && (
        showFormReview ? (
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormRating>
              <h1>Rate this Question</h1>
              <div className="d-flex align-items-center">
                <Rating
                  onClick={handleRating1}
                  size={36}
                  transition
                  fillColorArray={fillColorArray}
                />
              </div>
            </FormRating>
            <FormFeedback>
              <Input
                name="suggestion" 
                type="textarea" 
                placeholder="What could be improved in this question? Any suggestions?" 
                style={{ height: '180px' }}
                value={watch('suggestion')}
                onChange={(e) => setValue('suggestion', e.target.value)}
              />
              <div className='d-flex justify-content-end'>
                <ButtonComponent 
                  className="px-4"
                  disabled={(!watch('suggestion') || !watch('rate'))}
                >
                  Send Review
                </ButtonComponent>
              </div>
            </FormFeedback>
          </form>
        ) : (
          <div className='d-flex justify-content-end'>
            <ButtonComponent 
              className="add-review"
              onClick={() => setShowFormReview(true)}
            >
              Add a Review
            </ButtonComponent>
          </div>
        )
      )}
    </WrapFeedback>
  )
}
